(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    /*
   * ESTHEA (ESL-19, 30/9/2026; la 10 aprobada en móvil). Los botones de la fila de filtros
   * (.esthea-filtros-movil) abren el cajón de filtros de Horizon con su on:click; aquí se anota
   * cuál se pulsó y, cuando el cajón avisa de que está abierto (theme-drawer:open, después de
   * poner el foco en «Cerrar»), se lleva el foco a ese filtro dentro del cajón y se desplaza hasta
   * él. El on:click de Horizon escucha también en la fase de captura y se registra antes que este
   * guion, así que el cajón se abre antes de que el clic llegue aquí: por eso el foco se mueve en
   * el fotograma siguiente, cuando ya se sabe qué botón fue (medido el 30/9: sin esperar, cada
   * botón llevaba al filtro del botón pulsado la vez anterior). El foco sigue atrapado en el
   * cajón, Escape lo cierra y, al cerrarse, el foco vuelve al botón de la fila (assets/theme-drawer.js).
   */
  (() => {
    if (window.estheaFiltrosMovil) return;
    window.estheaFiltrosMovil = true;
    let destino = null;

    document.addEventListener(
      'click',
      (event) => {
        const boton = event.target instanceof Element ? event.target.closest('[data-esthea-destino]') : null;
        destino = boton ? boton.getAttribute('data-esthea-destino') : null;
      },
      true
    );

    const enfocar = (cajon) => {
      if (!destino || !cajon.hasAttribute('open')) return;
      const clave = destino;
      destino = null;
      let objetivo = null;
      if (clave === 'orden') {
        const select = cajon.querySelector('select.sorting-filter__select:not([disabled])');
        objetivo =
          select && select.getClientRects().length ? select : cajon.querySelector('.sorting-filter summary');
      } else {
        const interruptor = cajon.querySelector(`.esthea-interruptor-filtro[data-filter-param-name="${clave}"]`);
        if (interruptor) {
          objetivo = interruptor.querySelector('input');
        } else {
          const panel =
            cajon.querySelector(`details[id$="-${clave}"]`) ||
            cajon.querySelector(`#facet-inputs-${clave}`)?.closest('details');
          if (panel) {
            panel.open = true;
            objetivo = panel.querySelector('summary');
          }
        }
      }
      if (!(objetivo instanceof HTMLElement)) return;
      objetivo.focus({ preventScroll: true });
      objetivo.scrollIntoView({ block: 'start' });
    };

    document.addEventListener('theme-drawer:open', (event) => {
      const cajon = event.target;
      if (!(cajon instanceof HTMLElement) || cajon.id !== 'filters-drawer') return;
      requestAnimationFrame(() => enfocar(cajon));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
